import React from 'react';
import Footer from '../components/Footer';
import GamePage from '../components/GamePage';

import BalloonsOdyssey_Img01 from '../images/balloonsodyssey/images-02.png';


export default function BalloonsOdyssey_Skin01() {
  return (
    <>
      <GamePage
        name="Balloons Odyssey: Traveler skin"
        description="Traveler skin is the first skin you can get in Balloons Odyssey."
        images={[BalloonsOdyssey_Img01]}
        conclusion="Already implemented in the game Balloons Odyssey."
      />
      <Footer />
    </>
  );
}